import Modal from "@mui/material/Modal";
import { useContext } from "react";
import { Link } from "react-router-dom";
import Button from "../Button/Button";
import { AuthContext } from "../../contexts/AuthContext/AuthContext";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { OfficeState } from "../../models/office.model";
import { UserType } from "../../services/user.service";

export default function BlockRejectedOfficeModal() {
  const authContext = useContext(AuthContext);
  const { currentOffice } = useSelector((state: RootState) => state.office);
  const { currentUser } = useSelector((state: RootState) => state.currentUser);

  if (currentOffice?.officeState === OfficeState.Rejected && currentUser?.userType === UserType.OfficeAdmin)
    return (
      <Modal open={true} disableAutoFocus className="m-4">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-docsigna-orange w-full max-w-2xl flex flex-col items-center justify-center p-4 gap-4 rounded-lg">
          <h2 className="text-3xl text-white text-center font-semibold">
            We were unable to verify {currentOffice!.name} and have declined your office for publication at this time.
          </h2>
          <p className="text-white text-center">
            If you have any questions, please reach out to a Docnote Administrator at{" "}
            <Link to={"mailto:support@docnote.com"} className="underline">
              support@docnote.com
            </Link>
          </p>
          <Button
            text={"LOG OUT"}
            variant={"Secondary"}
            onClick={() => {
              // Preserve remembered email before clearing localStorage
              const rememberedEmail = localStorage.getItem("rememberedEmail");
              authContext?.signout();
              sessionStorage.clear();
              localStorage.clear();
              // Restore remembered email after clearing
              if (rememberedEmail) {
                localStorage.setItem("rememberedEmail", rememberedEmail);
              }
            }}
          />
        </div>
      </Modal>
    );
  else return null;
}
